import {
  CSSProperties,
  SyntheticEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { Icon, Modal } from "semantic-ui-react";
import { isIos, isMobile } from "react-lib/utils/mobileUtils";
import React from "react";

type ChatVideoContentProps = {
  file: File | string;
};

type Styles = Record<"playVideo", CSSProperties>;

const styles: Styles = {
  playVideo: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    marginLeft: "-3%",
    position: "absolute",
    width: "100%",
    top: 0,
  },
};

const IMAGES = {
  close: "/static/images/chat/image-viewer-close.png",
  playVideo: "/static/images/chat/play-video.png",
};

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};

const ChatVideoContent = (props: ChatVideoContentProps) => {
  const [video, setVideo] = useState<string | null>(null);
  const [duration, setDuration] = useState<number>(0);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!videoRef.current) {
      return () => {
        // ---
      };
    }

    const handleLoadedMetadata = () => {
      setDuration(videoRef.current?.duration ?? 0);
    };

    videoRef.current.addEventListener("loadedmetadata", handleLoadedMetadata);

    return () => {
      videoRef.current?.removeEventListener(
        "loadedmetadata",
        handleLoadedMetadata
      );
    };
  }, []);

  const videoSrc = useMemo(() => {
    return props.file instanceof File
      ? URL.createObjectURL(props.file)
      : props.file;
  }, []);

  const handleClick = (e: SyntheticEvent) => {
    console.log("Debug ~ e handleClick :", e)
    e.stopPropagation();
    if (isPlaying) {
        videoRef.current?.pause();
    } else {
        videoRef.current?.play();
    }
    // setVideo(videoSrc);
  };

  const handleClose = (e: SyntheticEvent) => {
    e.stopPropagation();
    videoRef.current?.pause();
    // setVideo(null);
  };

  const handleTogglePlay = () => {
    const video = videoRef.current;
    if (!video) return;

    if (!isIos() && isMobile()) {
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if ((video as any).webkitRequestFullscreen) {
        (video as any).webkitRequestFullscreen();
      } else if ((video as any).msRequestFullscreen) {
        (video as any).msRequestFullscreen();
      }
    }
  };

  return (
    <>
      <div
        className="file"
        style={{ cursor: "pointer", position: "relative" }}
        onClick={handleClick}
      >
        <video
          ref={videoRef}
          src={videoSrc}
          autoPlay={false}
          controls={isPlaying}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          style={{ width: "100%", borderRadius: "5px" }}
        />
        {!isPlaying && (
          <div style={styles.playVideo} onClick={handleTogglePlay}>
            <img
              style={{ width: "25px" }}
              alt="play-video"
              src={IMAGES.playVideo}
            />
            <div
              style={{
                color: "white",
                fontSize: "0.85rem",
                marginTop: "0.5rem",
              }}
            >
              {formatTime(duration)}
            </div>
          </div>
        )}
      </div>

      <Modal
        className="chat-box-content-video-viewer"
        open={!!video}
        closeOnDimmerClick
        onClick={handleClose}
        onClose={handleClose}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <video src={video || ""} autoPlay controls />
        </div>
        <div className="btn-close" onClick={handleClose}>
          <img alt="close" src={IMAGES.close} />
        </div>
      </Modal>
    </>
  );
};

export default ChatVideoContent;
